import { FinancesController } from './finances.controller';
import template from './finances.html';
import '../../../../common/ui/splitView/splitView';

export const financesComponent = {
  name: 'financesComponent',
  restrict: 'E',
  template,
  controller: FinancesController,
  controllerAs: 'vm',
  bindings: {
    aidRequest: '<'
  }
};
